<mat-dialog-content class="alert-modal-container">
	<h3 class="title"> {{title}}</h3>
	<p class="content">
		{{message}}
	</p>
</mat-dialog-content>
<mat-dialog-actions align="center" class="alert-modal-buttons">
	<button mat-raised-button mat-dialog-close *ngIf="dismissButtonText" (click)="onDismissClick()" tabindex="-1">{{dismissButtonText}}</button>
	<button mat-raised-button class="button-confirm" (click)="onConfirmClick()" tabindex="1">{{confirmButtonText}}</button>
</mat-dialog-actions>